module.exports = __webpack_public_path__ + "static/media/back-button.e5871fd4.png";